import type { FabricObject } from 'fabric';

type WithElement = { getElement?: () => { naturalWidth?: number; naturalHeight?: number } | undefined };

export const syncImageToNatural = (obj: FabricObject): void => {
  const el = (obj as WithElement).getElement?.();
  if (el?.naturalWidth && el?.naturalHeight) obj.set({ width: el.naturalWidth, height: el.naturalHeight });
};
